import CLabel from '@/components/main/CLabel';
import { Description, Favorite, Location, People, SalaryRange, Timer } from '@/components/Svg';
import { useAuthContext } from '@/context/AuthContext';
import t from '@/lib/localization';
import Currencies from '@/resources/currencies.json';
import { ActionIcon, Card, Grid, createStyles } from '@mantine/core';
import { IconEye } from '@tabler/icons-react';
import axios from 'axios';
import dayjs from 'dayjs';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import SignInModal from '../singin/SignInModal';
import Image from 'next/image';

const useStyles = createStyles((theme) => ({
  label: {
    fontSize: '12px',
  },
  favButton: {
    height: '32px',
    width: '32px',
    padding: '8px 10px',
  },
  appButton: {
    height: '32px',
    width: '62px',
    padding: '8px 10px',
  },
  title: {
    fontSize: '20px',
    lineHeight: '28px',
  },
  timer: {
    fontSize: '40px',
  },
  para: {
    color: '#A4A4A4',
    fontSize: '14px',
    lineHeight: '24px',
  },
  avatar: {
    height: '50px',
    width: '50px',
    borderRadius: '50%',
  },
  comName: {
    fontSize: '16px',
    lineHeight: '28px',
    color: '#777777',
  },
}));
//

export default function JobSmallCard({ job, dictionary, ...props }) {
  const { classes } = useStyles();
  const { user, bookmarks, isBookmark } = useAuthContext();
  const [bookmark, setBookmark] = useState(false);
  const [loginForm, setLoginForm] = useState(false);

  useEffect(() => {
    setBookmark(isBookmark(job.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(bookmarks)]);

  const handleFavorite = async () => {
    if (user == null) {
      setLoginForm(true);
    } else {
      if (bookmark) {
        try {
          setBookmark(false);
          await axios.delete('/api/favorite-jobs', {
            params: {
              id: job?.id,
            },
            headers: {
              Authorization: user.accessToken,
            },
          });
        } catch (error) {
          setBookmark(true);
        }
      } else {
        if (bookmarks.length >= 30) {
          showToaster(dictionary.bookmarkMessage, 'orange');
        } else {
          try {
            setBookmark(true);
            await axios.post(
              '/api/favorite-jobs',
              {
                id: job?.id,
                orgId: job?.createdBy?.id,
              },
              {
                headers: {
                  Authorization: user.accessToken,
                },
              }
            );
          } catch (error) {
            setBookmark(false);
          }
        }
      }
    }
  };

  return (
    <>
      <SignInModal show={loginForm} setShow={setLoginForm} dictionary={dictionary}></SignInModal>
      <Card padding={'lg'} style={{ borderRadius: '12px' }} withBorder {...props}>
        <Grid {...props}>
          <Grid.Col span={12}>
            <div className="flex flex-col">
              <div className="flex items-center justify-between">
                <div className="flex flex-wrap">
                  <CLabel
                    text={job?.jobType}
                    className={`${classes.label} me-[8px] my-1 text-xs`}
                  />
                  {job?.jobShift.map((shift, i) => (
                    <CLabel
                      key={i}
                      text={shift}
                      className={`${classes.label} me-[8px] my-1 text-xs`}
                    />
                  ))}{' '}
                </div>
                <div className="flex items-center justify-end mt-2 sm:mt-0 min-w-[100px] space-x-2">
                  <ActionIcon
                    size={'lg'}
                    variant={bookmark ? 'filled' : 'outline'}
                    onClick={handleFavorite}
                    color="blue"
                    aria-label={dictionary.bookmark}
                    title={dictionary.bookmark}
                  >
                    <Favorite width="11px" height="16px" />
                  </ActionIcon>

                  <Link
                    href={`/jobs/${job?.createdBy?.slug ?? job?.createdBy?.id}/${job.id}`}
                    className="no-underline "
                  >
                    <ActionIcon
                      size={'lg'}
                      variant="gradient"
                      aria-label={dictionary.details}
                      title={dictionary.details}
                    >
                      <Description />
                    </ActionIcon>
                  </Link>
                </div>
              </div>{' '}
              <Link
                href={`/jobs/${job?.createdBy?.slug ?? job?.createdBy?.id}/${job.id}`}
                className="no-underline "
              >
                <h3
                  className={`${classes.title} m-0 p-0 mt-[15px] mb-[15px] text-grayCustom hover:text-primary transition-all duration-200 whitespace-nowrap truncate`}
                >
                  {job?.jobTitle}
                </h3>
              </Link>
              <div className="flex">
                <div className="flex items-center w-1/2 text-primary">
                  <Timer height="18" width="18" />
                  <p className={`${classes.para} ms-[10px] m-0`}>
                    {dayjs(
                      job?.postingDate.seconds ? job?.postingDate?.toDate() : job?.postingDate
                    ).format('DD MMMM YYYY')}
                  </p>
                </div>
                <div className="flex items-center w-1/2 text-primary">
                  <Timer height="18" width="18" />
                  <p className={`${classes.para} ms-[10px] m-0`}>
                    {dayjs(
                      job?.closingDate.seconds
                        ? job?.closingDate?.toDate()
                        : job?.closingDate.seconds
                    ).format('DD MMMM YYYY')}
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap">
                <div className="flex flex-wrap items-center w-full text-primary">
                  <People height="18" width="18" />
                  <p className={`${classes.para} ms-[10px] m-0`}>
                    {t(dictionary.countVacancies, {
                      count: job?.noOfVacancies,
                    })}
                  </p>
                </div>

                <div className="flex flex-wrap items-center w-full text-primary">
                  <IconEye height="20" width="20" />
                  <p className={`${classes.para} ms-[10px] m-0`}>{job?.viewsCount ?? 0}</p>
                </div>

                <div className="flex items-center w-full text-primary flex-nowrap">
                  <SalaryRange height="18" width="18" />
                  <p className={`${classes.para} ms-[10px] m-0`}>
                    {job?.salaryNotSpecified
                      ? dictionary.notSpecified
                      : `${Currencies[job?.currency]}${job?.minimumSalary} - ${
                          Currencies[job?.currency]
                        }${job?.maximumSalary}`}{' '}
                  </p>
                </div>
              </div>
              <div className="flex items-center mt-[15px]">
                <Link
                  href={`/jobs/${job?.createdBy?.slug ?? job?.createdBy?.id}/${job.id}`}
                  className="no-underline "
                >
                  <Image
                    height={50}
                    width={50}
                    
                    src={job?.createdBy?.photoURL ?? '/images/user.svg'}
                    className={`${classes.avatar} rounded-full`}
                    alt={job?.createdBy?.displayName}
                  />
                </Link>
                <Link
                  href={`/jobs/${job?.createdBy?.slug ?? job?.createdBy?.id}/${job.id}`}
                  className="no-underline "
                >
                  <div className="flex flex-col ml-[12px]">
                    <h3 className={`${classes.comName} m-0 p-0`}>{job?.createdBy?.displayName}</h3>
                    <div className="flex items-center">
                      <Location height="16px" width="13px" color="#A4A4A4" />
                      <p className={`${classes.para} ms-[8px]  m-0 text-[12px]`}>{job?.location}</p>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </Grid.Col>
        </Grid>
      </Card>
    </>
  );
}
